<div class="container">
  <div class="row">
    <div class="col-md-12 d-flex flex-column align-items-center mt-5">
      <h1 class="title mb-3">Welcome to your Stories Dashboard!</h1>
      <div class="row">
        <div class="col-md-5 card col-sm-12 p-4">
          <div class="card-body">
            <p class="fs-6">
              Brainstorm new story ideas below to get started writing your life
              story.
            </p>
            <form
              [formGroup]="addBrainstormForm"
              class="row col-12"
              (ngSubmit)="addBrainstorm()">
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  formControlName="brainstorm"
                  placeholder="Start a new brainstorm"
                  required=""
                  [ngClass]="
                    ngClassValidate(addBrainstormForm, 'brainstorm')
                  " />
              </div>
              <div class="col-2">
                <button
                  class="btn btn-primary btn-block btn-submit"
                  type="submit">
                  +
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-7 card">
          <div class="card-body" id="brainstorming-panel-pick-idea">
            <h3>Need inspiration?</h3>
            <p class="fs-6">
              Click any topic below to add it to your brainstorming worksheet.
            </p>

            <div class="sample-topics mb-3">
              <div class="row">
                <div class="">
                  <button
                    class="btn mb-2 text-white w-100"
                    *ngFor="let inspiration of inspirationList"
                    [ngStyle]="{ 'background-color': inspiration.color }">
                    {{ inspiration.value }}
                  </button>
                </div>
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-primary" id="more-brainstorming-ideas">
                View more ideas
              </button>
            </div>
          </div>
        </div>
        <h2 class="text-center my-3 title">My Brainstorms</h2>
        <ng-container *ngIf="brainstorms.length; else empty">
          <div class="row my-1 p-3 bg-light align-items-center">
            <div class="col-12 col-md-4">
              <h5 class="m-0">
                Brainstorm
                <sup>
                  <i
                    class="fas fa-question-circle"
                    placement="top"
                    ngbTooltip="Brainstorm are your stories ideas."></i>
                </sup>
              </h5>
            </div>
            <div class="d-none d-md-inline col-md-8">
              <div class="row align-items-center">
                <div class="col-2 text-center">
                  <h6 class="m-0">
                    Attachments
                    <sup>
                      <i
                        class="fas fa-question-circle"
                        placement="top"
                        ngbTooltip="Upload photos and supporting documents to your story."></i>
                    </sup>
                  </h6>
                </div>
                <div class="col-2 text-center">
                  <h6 class="m-0">
                    Write
                    <sup>
                      <i
                        class="fas fa-question-circle"
                        placement="top"
                        ngbTooltip="Write your story."></i>
                    </sup>
                  </h6>
                </div>
                <div class="col-2 text-center">
                  <h6 class="m-0">
                    Details
                    <sup>
                      <i
                        class="fas fa-question-circle"
                        placement="top"
                        ngbTooltip="Add story category, location, select dates and tag people."></i>
                    </sup>
                  </h6>
                </div>

                <div class="col-2 text-center">
                  <h6 class="m-0">
                    Audio
                    <sup>
                      <i
                        class="fas fa-question-circle"
                        placement="top"
                        ngbTooltip="Record audio for your story."></i>
                    </sup>
                  </h6>
                </div>

                <div class="col-2 text-center">
                  <h6 class="m-0">
                    Publish
                    <sup>
                      <i
                        class="fas fa-question-circle"
                        placement="top"
                        ngbTooltip="Complete Attachments, Write, and Details sections to publish your story. Sections with gray icons are incomplete."></i>
                    </sup>
                  </h6>
                </div>

                <div class="col-2 text-center">
                  <h6 class="m-0">Delete</h6>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row my-1 p-2 align-items-center border-bottom"
            *ngFor="let b of brainstorms; let i = index">
            <div class="col-12 col-md-4">
              <p class="mb-2 mb-md-0 font-size-14">
                {{ b }}
              </p>
            </div>
            <div class="col-12 col-md-8">
              <div class="row align-items-center">
                <div class="col-2 text-center">
                  <button type="submit" class="btn btn-primary btn-edit">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="col-2 text-center">
                  <button type="submit" class="btn btn-primary btn-edit">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </div>
                <div class="col-2 text-center">
                  <button type="submit" class="btn btn-primary btn-edit">
                    <i class="fas fa-list-alt"></i>
                  </button>
                </div>

                <div class="col-2 text-center">
                  <button type="submit" class="btn btn-primary btn-edit">
                    <i class="fas fa-microphone-alt"></i>
                  </button>
                </div>

                <div class="col-2 text-center">
                  <button type="submit" class="btn btn-primary btn-edit">
                    <i class="fas fa-book"></i>
                  </button>
                </div>

                <div class="col-2 text-center">
                  <button
                    type="submit"
                    class="btn btn-danger btn-edit"
                    (click)="deleteBrainstorm(i)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #empty>
  <div class="row justify-content-center py-2">
    <div class="col-12">
      <div class="border">
        <p class="text-center my-3">You don't have any brainstorms yet!</p>
      </div>
    </div>
  </div>
</ng-template>
